import React from 'react';
import Cell from './Cell';
import { getHighlightedCells } from '../utils/highlighting';

const Board = ({ puzzle, userGrid, notes, selectedCell, flashCell, filterDigit = null, onCellClick }) => {
  const { peers, sameNumber } = getHighlightedCells(selectedCell, userGrid, filterDigit, notes);

  return (
    <div className="grid grid-cols-9 w-full max-w-[540px] aspect-square mx-auto border-2 border-gray-700 dark:border-gray-400">
      {userGrid.map((rowValues, r) =>
        rowValues.map((value, c) => {
          const key = `${r}-${c}`;
          return (
            <Cell
              key={key}
              row={r}
              col={c}
              value={value}
              isGiven={puzzle[r][c] !== 0}
              notes={notes[r][c]}
              isSelected={selectedCell.row === r && selectedCell.col === c}
              isPeer={peers.has(key)}
              isSameNumber={sameNumber.has(key)}
              isError={!!flashCell && flashCell.row === r && flashCell.col === c}
              onClick={onCellClick}
            />
          );
        })
      )}
    </div>
  );
};

export default Board;
